import ElementUI from 'element-ui'
import Vue from 'vue'
import dataApi from '../../../api/index.js'
import router from '../../../router'

const namespaced = true

const state = {
  currentSession: {
    state: 'undefined',
    visible: false,
    createdAt: 0,
    loadedAt: 0,
    refreshingAt: 0,
    data: {
      session: {},
      user: undefined
    },
    type: '',
    roles: {},
    parentUuids: {}
  }
}

function handleAuthLogin (response) {
  // geldig data response!

  // success!, 200 status is gelukt
  if (response.status === 200 && response.body.message) {
    const [token, refreshToken] = response.body.message
    if (!token || !refreshToken) {
      state.currentSession.state = 'error'
      return
    }
    const authData = {
      jwt_token: token,
      refresh_token: refreshToken,
      createdAt: (new Date()).getTime()
    }
    window.localStorage.setItem('vega', JSON.stringify(authData))
    window.localStorage.setItem('id_token', token)
    window.localStorage.setItem('id_refresh_token', refreshToken)
    window.localStorage.setItem('id_token_created_at', (new Date()).getTime())
    state.currentSession.loadedAt = Date.now()
    state.currentSession.data.session = {id_token: token}

    state.currentSession.state = 'undefined'

    router.push({name: 'management.unit'})
  } else {
    state.currentSession.state = 'error'
  }
}

function handleAuthLoginError (response) {
  // Handle MFA required.
  if (response.body && response.body.msgId === 'MFA_REQUIRED') {
    window.localStorage.setItem('mfaTemporalToken', response.body.data)
    router.push({ query: { ...router.query, mfa: 'true' } })
    return
  }
  // error
  state.currentSession.state = 'error'
  if (response.body.message[0] === 'LOCKED') {
    state.currentSession.data.error = { message: Vue.t('server_messages.LOCKED') }
  } else {
    state.currentSession.data.error = { message: Vue.t('server_messages.INVALID_CREDENTIALS') }
  }
}

const decodeToken = (token) => {
  try {
    const payload = token.split('.')[1]
    return JSON.parse(window.atob(payload))
  } catch (e) {
    return null
  }
}

function getJwtToken () {
  let idToken = window.localStorage.getItem('id_token')
  if (!idToken) {
    const vegaData = window.localStorage.getItem('vega')
    if (vegaData) {
      const { jwt_token: jwtToken } = JSON.parse(vegaData)
      idToken = jwtToken
    }
  }
  return idToken
}

function getRefreshToken () {
  let refreshToken = window.localStorage.getItem('id_refresh_token')
  if (!refreshToken) {
    const vegaData = window.localStorage.getItem('vega')
    if (vegaData) {
      const { refresh_token: idRefreshToken } = JSON.parse(vegaData)
      refreshToken = idRefreshToken
    }
  }
  return refreshToken
}

const mutations = {
  authLogin (state, credentials) {
    // create a new user JWT token
    state.currentSession.state = 'loading'
    dataApi.endpoints.auth.authLogin(credentials).then((response) => {
      handleAuthLogin(response)
    }, (response) => {
      handleAuthLoginError(response)
    })
  },
  authLoginMfa (state, mfaRequest) {
    // create a new user JWT token using MFA auth.
    state.currentSession.state = 'loading'
    dataApi.endpoints.auth.authLoginMfa(mfaRequest).then((response) => {
      handleAuthLogin(response)
    }, (response) => {
      handleAuthLoginError(response)
    })
  },
  sessionError (state) {
    window.localStorage.removeItem('vega')
    window.localStorage.removeItem('id_token')
    window.localStorage.removeItem('id_token_created_at')

    state.currentSession.data.error = { message: Vue.t('server_messages.INVALID_CREDENTIALS') }

    if (state.currentSession.state === 'logout') {
      state.currentSession.data.error = { message: Vue.t('server_messages.LOGOUT') }
    }

    if (state.currentSession.state !== 'loading') {
      state.currentSession.data.error = { message: Vue.t('server_messages.UNAUTHORIZED') }
    }

    state.currentSession.state = 'error'
    ElementUI.Message.warning({ message: state.currentSession.data.error.message })
  },
  // Clear session without showing UI warnings (used when logout fails due to expired session)
  clearSessionSilent (state) {
    window.localStorage.removeItem('vega')
    window.localStorage.removeItem('id_token')
    window.localStorage.removeItem('id_token_created_at')
    window.localStorage.removeItem('id_refresh_token')

    state.currentSession.data = {
      session: {},
      user: undefined
    }
    state.currentSession.roles = {}
    state.currentSession.state = 'logout'
  },
  logoutCurrentSession (state) {
    if (getJwtToken()) {
      // there is a token, please try to unset this
      dataApi.endpoints.auth.logout(getRefreshToken()).then((response) => {
        window.localStorage.removeItem('vega')
        window.localStorage.removeItem('id_token')
        window.localStorage.removeItem('id_token_created_at')
        window.localStorage.removeItem('id_refresh_token')
        state.currentSession.data = {
          session: {},
          user: undefined
        }
        state.currentSession.roles = {}
        state.currentSession.state = 'logout'
        window.location.reload(true)
      }, (err) => {
        console.log('err', err)
        window.localStorage.removeItem('vega')
        window.localStorage.removeItem('id_token')
        window.localStorage.removeItem('id_token_created_at')
        state.currentSession.data = {
          session: {},
          user: undefined
        }
        state.currentSession.roles = {}
        state.currentSession.state = 'logout'
      })
    }
  },
  checkSession (state, options) {
    // get loadedAt from store!
    if (state.currentSession.state === 'undefined') {
      // not yet loaded!!
      // get logged in username and role!
      // check if there is a token set..
      // else go to the login page ..
      const token = getJwtToken()

       // skip this function if we are resetting password in order to get to that form
      const currentRoute = window.location.pathname
      const resetPasswordForm = currentRoute.includes('resetPassword')

      if (!token && !resetPasswordForm) {
        router.push({
          name: 'login'
        })
      }

      const idToken = window.localStorage.getItem('id_token')
      state.currentSession.state = 'loading'
      state.currentSession.data.session = {id_token: token}

      let jwtPayload = null
      if (!resetPasswordForm) {
        if (idToken) {
          jwtPayload = decodeToken(idToken)
        }

        if (jwtPayload && jwtPayload.sub && jwtPayload.name) {
          state.currentSession.data.user = {
            uuid: jwtPayload.sub && jwtPayload.sub.startsWith('f:')
              ? jwtPayload.sub.split(':')[2]
              : jwtPayload.sub,
            name: jwtPayload.name
          }
          dataApi.endpoints.user.getGet({uuid: state.currentSession.data.user.uuid}).then((userDetailsResponse) => {
            // succes from /ui/user/getGet
            state.currentSession.state = 'ready'
            state.currentSession.data.user = Object.assign(state.currentSession.data.user, userDetailsResponse.body)
            state.currentSession.loadedAt = Date.now()
          }, (error) => {
            // error
            state.currentSession.state = 'error'
            state.currentSession.data.error = error
            router.push({
              name: 'login'
            })
          })
        } else {
          // now please refresh the user
          dataApi.endpoints.user.getWhoAmI().then((whoIAmResponse) => {
            // succes from /ui/user/who-am-i
            state.currentSession.data.user = whoIAmResponse.body

            dataApi.endpoints.user.getGet({uuid: state.currentSession.data.user.uuid}).then((userDetailsResponse) => {
              // succes from /ui/user/getGet
              state.currentSession.state = 'ready'
              state.currentSession.data.user = Object.assign(state.currentSession.data.user, userDetailsResponse.body)
              state.currentSession.loadedAt = Date.now()
            }, (error) => {
              // error
              state.currentSession.state = 'error'
              state.currentSession.data.error = error
              router.push({
                name: 'login'
              })
            })
          }, (whoIAmResponse) => {
            // error
            state.currentSession.state = 'error'
            router.push({
              name: 'login'
            })
          })
        }
      } else {
        // keep same state for now
        state.currentSession.data.error = { message: 'Unauthorized access or an expired session' }
      }
    }
  },
  setRoles (state, roles) {
    state.currentSession.roles = roles
  }
}

const getters = {
  getCurrentSession: (state) => {
    return state.currentSession
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/session.js